// extracted by mini-css-extract-plugin
export default {"skelleton":"FaqSkelleton_skelleton__byzr2"};